// 1. Attendance.jsx
import { useNavigate } from 'react-router-dom';
import { FiPlus } from "react-icons/fi";

const AttendanceList = () => {
  const navigate = useNavigate();
  const days = [
    { date: '28 Dec 2024', status: 'Present' },
    { date: '28 Dec 2024', status: 'Absent' },
    { date: '28 Dec 2024', status: 'Undertime', note: true },
  ];

  return (
    <div className="p-4 min-h-screen bg-white">
      <div className="flex items-center gap-4 mb-4">
        <button onClick={() => navigate(-1)}>&larr;</button>
        <h1 className="text-lg font-bold">Attendance</h1>
      </div>

      <div className="grid grid-cols-2 gap-4 mb-4">
        <input type="date" className="border p-2 rounded" placeholder="Start Date" />
        <input type="date" className="border p-2 rounded" placeholder="End Date" />
      </div>

      <div className="grid grid-cols-4 gap-2 text-center mb-4 text-sm">
        <div className="bg-gray-100 p-2 rounded">Present<br />00</div>
        <div className="bg-gray-100 p-2 rounded">Absent<br />00</div>
        <div className="bg-gray-100 p-2 rounded">Undertime<br />00</div>
        <div className="bg-gray-100 p-2 rounded">Overtime<br />00</div>
      </div>

      {days.map((day, index) => (
        <div key={index} className="flex justify-between items-center bg-gray-50 p-3 rounded mb-2 shadow">
          <p className="text-sm">{day.date}</p>
          {day.note ? (
            <div className="flex gap-2 text-xs">
              <button className="bg-red-500 text-white px-2 py-1 rounded">+ Add Notes</button>
              <span className="bg-yellow-300 text-xs px-2 py-1 rounded">Undertime</span>
              <span className="bg-red-500 text-white px-2 py-1 rounded">Overtime</span>
            </div>
          ) : (
            <span className={`text-xs px-3 py-1 rounded-full ${
              day.status === 'Present' ? 'bg-green-500 text-white' : 'bg-red-500 text-white'
            }`}>
              {day.status}
            </span>
          )}
        </div>
      ))}


      <div>
         <button
    
      className="fixed bottom-6 right-6 bg-red-600 hover:bg-red-700 text-white p-4 rounded-full shadow-lg z-50"
    >
      <FiPlus className="text-2xl" />
    </button>
      </div>

    </div>
  );
};

export default AttendanceList;